export function useStoreDateTime() {
    return useState('dateTime', () => '')
}